import React from 'react';

const TermsOfUse = () => {

    return (
        <div style={{padding: 18}}>
    <h2 align="center" style={{marginTop: 24, marginBottom: 24}}>
                <strong>Understanding Ag, LLC Terms of Use</strong>
                <strong></strong>
            </h2>
            <p>
                Last Modified: October 6, 2021
</p>
            <h3>
                <a name="_5s47gkti4f49"> </a>
                <strong>Acceptance of the Terms of Use</strong>
            </h3>
            <p>
                These terms of use are entered into by and between you and the Understanding Ag, LLC (the &#8220;<strong>UA</strong>&#8221;,
    &#8220;<strong>we</strong>&#8221; or &#8220;<strong>us</strong>&#8221;).
    The following terms and conditions, together with any documents they
expressly incorporate by reference (collectively, these &#8220;    <strong>Terms of Use</strong>&#8221;), govern your access to and use of the
    UA website, UNDERSTANDINGAG.COM (the &#8220;<strong>Website</strong>
    &#8221;), and any content, functionality and services offered on or through
    the Website (collectively, the &#8220;<strong>Services</strong>&#8221;).
</p>
            <p>
                Please read these Terms of Use carefully before you start to use the
                Services.
    <strong>
                    By using the Services or by clicking to accept or agree to the Terms of
                    Use when this option is made available to you, you accept and agree to
                    be bound and abide by these Terms of Use, our Acceptable Use Policy and
                    our Privacy Policy, each incorporated herein by reference
    </strong>
    . If you do not agree to these Terms of Use, the Acceptable Use Policy or
    the Privacy Policy, you must not access or use the Services. Certain areas
within the Services may be governed by additional terms (&#8220;    <strong>Additional Terms</strong>&#8221;), incorporated herein by
    reference. By using those areas of the Services, you agree to the
    Additional Terms.
</p>
            <p>
                The Services are offered and available to users who are 13 years of age or
                older and reside in the United States or any of its territories or
                possessions.
</p>
            <h3>
                <a name="_fxctyhbvm8ht"></a>
                <strong>Courses and Certification of Completion</strong>
            </h3>
            <p>
            Understanding Ag’s purpose is to provide educational courses in a wide range of 
            subjects relating to regenerative agriculture (each, a <strong>“Course”</strong>). In order to 
            allow for a variety of Courses, each Course will only be available for a specific 
            term (<strong>“Term”</strong>), during which time Course content (<strong>“Content”</strong>) will be made available 
            to students who have paid for access. The Term for each Course will be noted on 
            the webpage for the Course, and you will be able to purchase access to a Course 
            up to two weeks prior to the end of the then-current Term. At the end of the Term, 
            the Course will no longer be available for completion. You are responsible for 
            ensuring that you will be able to complete the Course within the allotted Term.

</p>
            <p>
                Once UA has determined that a subscriber has completed the course it will
                email the subscriber a certificate of completion.
</p>
            <h3>
                <a name="_1t27ml7k8zjw"></a>
                <strong>Payments</strong>
            </h3>
            <p>
                All payments are handled through our third-party vendor, Stripe, Inc. If
                you wish to register for any Courses (each such purchase, a
                &#8220;Transaction&#8221;), you may be asked to supply certain information
                relevant to your Transaction including, without limitation, your credit
                card number, the expiration date of your credit card, your billing address,
                and your shipping information. By submitting such information, you grant to
                our third-party payment processor the right to process such information for
                purposes of facilitating the completion of any Transaction initiated by you
                or on your behalf.
</p>
            <h3>
                <a name="_b9fxvwzd0lpc"></a>
                <strong>Refunds</strong>
            </h3>
            <p>
                UA does not offer refunds for cancellations once you have subscribed to
                the Content. As noted below, we reserve the right to update, change, add
                and remove content from the course, at our sole discretion. In the event
                that we remove a Course so that you are unable to complete the Course
                before the end of the applicable Term, we will provide a full refund of the
                amount you paid for the Course. If you have any questions about our refund
                policy, you may send an email to support@regenagonline.com. Please note that if
                we believe you are abusing our refund policy, we reserve the right to
                suspend or terminate your account and refuse or restrict any and all
                current or future use of the Services, without any liability to you.
</p>
            <h3>
                <a name="_rwrakg99y5n2"></a>
                <strong>Accessing the Services and Account Security</strong>
            </h3>
            <p>
                We reserve the right to modify or terminate the Services, and any service
                or material we provide in connection with the Services, in our sole
                discretion without notice. We will not be liable if, for any reason, all or
                any part of the Services are unavailable at any time or for any period.
                From time to time, we may restrict access to some or all of the Services.
</p>
            <p>
                You are responsible for making all arrangements necessary for you to have
                access to the Services.
</p>
            <p>
                To access the Services, you may be asked to provide certain registration
                details or other information. It is a condition of your use of the Services
                that all the information you provide on the Services is correct, current
                and complete. You agree that all information you provide through the
                Services is governed by our Privacy Policy.
</p>
            <p>
                We have the right to disable any registered accounts, whether chosen by you
                or provided by us, at any time in our sole discretion if, in our opinion,
                you have violated any provision of these Terms of Use.
</p>
            <h3>
                <a name="_z5xzyona0l7p"></a>
                <strong>Intellectual Property Rights</strong>
            </h3>
            <p>
                The Services, including but not limited to all information, software, text,
                displays, images, video and audio, and the design, selection and
                arrangement thereof, are owned by UA and Narrasys Inc., its licensors or
                other providers of such material and are protected by United States and
                international copyright, trademark, patent, trade secret and other
                intellectual property or proprietary rights laws.
</p>
            <p>
            Subject to these Terms of Use, we grant you a limited, personal, non-exclusive, 
            non-transferable and revocable license to use the Services. You may download 
            Content from the Services only for your personal, non-commercial use, unless 
            you obtain UA’s written permission to otherwise use the content. You also agree 
            that you will create, access and/or use only one user account, and you will not 
            share your account or account access information with anyone else. Except for the 
            license granted herein, all right, title and interest in and to the Services or
             any content on the Services are owned by UA.

</p>
            <p>
                We welcome your suggestions, comments, and other feedback regarding the
    Services (&#8220;<strong>Feedback</strong>&#8221;). By submitting any
    Feedback, you grant us the right to use the Feedback without any
    restriction or any compensation to you. By accepting your Feedback, we do
    not waive any rights to use similar or related Feedback previously known to
    us, developed by our employees or contractors, or obtained from other
    sources.
</p>
            <h3>
                <a name="_r80m9kfh8jn7"></a>
                <strong>Trademarks</strong>
            </h3>
            <p>
                The UA name, Understanding Ag, LLC, and all
                related names, logos, product and service names, designs and slogans are
                trademarks of UA or its affiliates or licensors. You may not use such
                marks without the prior written permission of UA. All other names, logos,
                product and service names, designs and slogans on these Services are the
                trademarks of their respective owners.
</p>
            <h3>
                <a name="_eqss87f4fwm"></a>
                <strong>User Contributions</strong>
            </h3>
            <p>
                The Services may contain message boards, chat rooms, personal web pages or
                profiles, forums, Course discussion boards and other interactive features
    (collectively, &#8220;<strong>Interactive Services</strong>&#8221;) that
    allow users to post, submit, publish, display or transmit to other users or
    other persons (hereinafter, &#8220;<strong>post</strong>&#8221;) content or
    materials (collectively, &#8220;<strong>User Contributions</strong>&#8221;)
    on or through the Services.
</p>
            <p>
                All User Contributions must comply with the Content Standards set forth in
                our Acceptable Use Policy. Any User Contribution you post to the Website,
                as well as all Feedback, will be considered non-confidential and
                non-proprietary. By providing any User Contribution on the Services, you
                grant us and our affiliates and service providers, and each of their and
                our respective licensees, successors and assigns the right to use,
                reproduce, modify, perform, display, distribute and otherwise disclose to
                third parties any such material for any purpose.
</p>
            <p>
                You represent and warrant that:
</p>
            <p>
                &#9679; You own or have obtained all rights in and to the User
                Contributions and have the right to grant the license granted above to us
                and our affiliates and service providers, and each of their and our
                respective licensees, successors and assigns.
</p>
            <p>
                &#9679; All of your User Contributions do and will comply with these Terms
                of Use and Acceptable Use Policy.
</p>
            <p>
                You understand and acknowledge that you are responsible for any User
                Contributions you submit or contribute, and you, not UA, have sole
                responsibility for such content, including its legality, reliability,
                accuracy and appropriateness.
</p>
            <p>
                We are not responsible, or liable to any third party, for the content or
                accuracy of any User Contributions posted by you or any other user of the
                Services.
</p>
            <h3>
                <a name="_hj2uve91mo6y"></a>
                <strong>Monitoring and Enforcement; Termination</strong>
            </h3>
            <p>
                We have the right to:
</p>
            <p>
                &#9679; Remove or refuse to post any User Contributions for any or no
                reason in our sole discretion.
</p>
            <p>
                &#9679; Take any action with respect to any User Contribution that we deem
                necessary or appropriate in our sole discretion, including if we believe
                that such User Contribution violates these Terms of Use, including the
                Content Standards, infringes any intellectual property right or other right
                of any person or entity, threatens the personal safety of users of the
                Services or the public, or could create liability for UA.
</p>
            <p>
                &#9679; Disclose your identity or other information about you to any third
                party who claims that material posted by you violates their rights,
                including their intellectual property rights or their right to privacy.
</p>
            <p>
                &#9679; Take appropriate legal action, including without limitation,
                referral to law enforcement, for any illegal or unauthorized use of the
                Services.
</p>
            <p>
                &#9679; Terminate or suspend your access to all or part of the Services for
                any violation of these Terms of Use.
</p>
            <p>
                Without limiting the foregoing, we have the right to cooperate with law
                enforcement authorities or court order requesting or directing us to
                disclose the identity or other information of anyone posting any materials
                on or through the Services.
</p>
            <p>
                We do not undertake to review all material before it is posted on the
                Services, and cannot ensure prompt removal of objectionable material after
                it has been posted. Accordingly, we assume no liability for any action or
                inaction regarding transmissions, communications or content provided by any
                user or third party. We have no liability or responsibility to anyone for
                performance or nonperformance of the activities described in this section.
</p>
            <h3>
                <a name="_mghkjespj59p"></a>
                <strong>Copyright Infringement Policy</strong>
            </h3>
            <p>
                If you believe your copyright or the copyright of a person on whose behalf
                you are authorized to act has been infringed, you may notify our copyright
                agent:
</p>
            <div>
                <h2>
                    <a name="_bi35y1tv04pp"></a>
                    <strong>Understanding Ag, LLC</strong>
                    <strong></strong>
                </h2>
                <p>
                    1908 Spring Drive NW
        <br />
        Fort Payne AL 35968
    </p>
                <p>
                    256-996-3142
    </p>
                <p>
                    Copyright &#169; 2021 Understanding Ag, LLC
    </p>
                <p>
                    Attn: Copyright Agent
    </p>
                <p>
                    Email: support@regenagonline.com
    </p>
            </div>
            <p>
                To be effective, your notification must (i) be in writing and signed, (ii)
                be provided to our copyright agent, and (iii) include substantially the
                following:
</p>
            <p>
                &#9679; Identify specifically the copyrighted work(s) believed to have been
                infringed (for example, &#8220;My copyrighted work is the picture that
                appears at [list location where material is located].&#8221;);
</p>
            <p>
                &#9679; Identify the content that a copyright owner claims is infringing
                upon copyrighted work. The copyright owner must provide information
                reasonably sufficient to enable us to locate the item on the Website or
                Services. The copyright owner should provide clear screenshots of the
                allegedly infringing materials for identification purposes only. The
                information provided should be as detailed as possible;
</p>
            <p>
                &#9679; Provide information sufficient to permit us to contact the
                copyright owner directly: name, street address, telephone number, and email
                (if available);
</p>
            <p>
                &#9679; If available, provide information sufficient to permit us to notify
                the alleged infringer (email address preferred);
</p>
            <p>
                &#9679; A statement that the complaining party has a good faith belief that
                use of the material in the manner complained of is not authorized by the
                copyright owner, its agent, or the law; and
</p>
            <p>
                &#9679; A statement that the information in the notification is accurate,
                and under penalty of perjury, that the complaining party is authorized to
                act on behalf of the owner of an exclusive right that is allegedly
                infringed.
</p>
            <p>
                UA has the right to remove any Content, User Contributions, or other
                material from the Website or Services at any time.
</p>
            <h3>
                <a name="_drfy7efxra3g"></a>
                <strong>Reliance on Information Posted</strong>
            </h3>
            <p>
                These Services may include content provided by third parties, including
                materials provided by other users and third-party licensors, syndicators,
                aggregators and/or reporting services. All statements and/or opinions
                expressed in the materials, and all articles and responses to questions and
                other content, other than the content provided by the Foundation, are
                solely the opinions and the responsibility of the person or entity
                providing the materials. The materials do not necessarily reflect the
                opinion of UA. We are not responsible, or liable to you or any third
                party, for the content or accuracy of any materials provided by any third
                parties.
</p>
            <h3>
                <a name="_d5j1pl3q4884"></a>
                <strong>Changes to the Services</strong>
            </h3>
            <p>
                We may update the content on or through the Services from time to time, but
                the content is not necessarily complete or up-to-date. Any of the material
                on the Services, including Content, may be out of date at any given time
                and while we make a good faith effort to keep the Content up-to-date, we
                cannot guarantee that it will be.
</p>
            <h3>
                <a name="_4av7ull6qary"></a>
                <strong>Information About You and Your Use of the Services</strong>
            </h3>
            <p>
                All information we collect on or through the Services is subject to our
                Privacy Policy.
</p>
            <p>
                <strong></strong>
            </p>
            <p>
                <strong>Links from the Services</strong>
            </p>
            <p>
                If the Services contain links to other sites and resources provided by
                third parties, these links are provided for your convenience only. This
                includes links contained in advertisements, including banner advertisements
                and sponsored links. Linking to a website does not constitute endorsement
                by the Foundation, or any of our employees, of the sponsors of the site or
                the products presented on the site. We have no control over the contents of
                those sites or resources, and accept no responsibility for them or for any
                loss or damage that may arise from your use of them. If you decide to
                access any of the third party websites linked to these Services, you do so
                entirely at your own risk and subject to the terms and conditions of use
                and privacy policies for such websites.
</p>
            <h3>
                <a name="_q3w0zyptn3kd"></a>
                <strong>Geographic Restrictions</strong>
            </h3>
            <p>
                The Services are intended for use only by persons located in the United
                States. We make no claims that the Services or any content is accessible or
                appropriate outside of the United States. Access to the Services may not be
                legal by certain persons or in certain countries. If you access the
                Services from outside the United States, you do so on your own initiative,
                at your sole risk, and you are responsible for compliance with local laws.
</p>
            <h3>
                <a name="_ez1vezy1r0ky"></a>
                <strong>Disclaimer of Warranties</strong>
            </h3>
            <p>
                You understand that we cannot and do not guarantee or warrant that files
                available for downloading from the Services will be free of viruses or
                other destructive code. You are responsible for implementing sufficient
                procedures and checkpoints to satisfy your particular requirements for
                anti-virus protection and accuracy of data input and output, and for
                maintaining a means external to our site for any reconstruction of any lost
                data. WE ARE NOT LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED
                DENIAL-OF-SERVICE ATTACK, VIRUSES OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL
                THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA OR OTHER
                PROPRIETARY MATERIAL DUE TO YOUR USE OF THE SERVICES OR ANY SERVICES OR
                ITEMS OBTAINED THROUGH THE SERVICES OR TO YOUR DOWNLOADING OF ANY MATERIAL
                POSTED ON THE SERVICES, OR ON ANY WEBSITE LINKED TO OR FROM THE SERVICES.
</p>
            <p>
                YOUR USE OF THE SERVICES, THE CONTENT AND ANY SERVICES OR ITEMS OBTAINED
                THROUGH THE SERVICES IS AT YOUR OWN RISK, AND THE SERVICES, THEIR CONTENT
                AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE SERVICES ARE PROVIDED ON AN
                &#8220;AS IS&#8221; AND &#8220;AS AVAILABLE&#8221; BASIS. UNLESS OTHERWISE
                SET FORTH IN THESE TERMS OF USE, NEITHER UA NOR ANY PERSON ASSOCIATED WITH
                UA MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS,
                SECURITY, RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE SERVICES.
                WITHOUT LIMITING THE FOREGOING, NEITHER UA NOR ANYONE ASSOCIATED WITH UA
                REPRESENTS OR WARRANTS THAT THE SERVICES, THEIR CONTENT OR ANY SERVICES OR
                ITEMS OBTAINED THROUGH THE SERVICES WILL BE ACCURATE, RELIABLE, ERROR-FREE
                OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR WEBSITE OR THE
                SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL
                COMPONENTS OR THAT THE SERVICES OR ANY SERVICES OR ITEMS OBTAINED THROUGH
                THE SERVICES WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
</p>
            <p>
                UA HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
                IMPLIED, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY,
                NON-INFRINGEMENT AND FITNESS FOR PARTICULAR PURPOSE.
</p>
            <p>
                THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR
                LIMITED UNDER APPLICABLE LAW.
</p>
            <h3>
                <a name="_fbxwbai9a6wx"></a>
                <strong>Limitation on Liability</strong>
            </h3>
            <p>
                IN NO EVENT WILL UA, ITS AFFILIATES OR THEIR LICENSORS, SERVICE PROVIDERS,
                EMPLOYEES, AGENTS, OFFICERS OR DIRECTORS BE LIABLE FOR ANY INDIRECT,
                SPECIAL, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES (INCLUDING BUT NOT
                LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS
                OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS
                OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT
                (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF
                FORESEEABLE) UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH
                YOUR USE, OR INABILITY TO USE, THE SERVICES, ANY CONTENT ON THE SERVICES OR
                SUCH OTHER WEBSITES OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SERVICES
                OR SUCH OTHER WEBSITES. YOUR SOLE REMEDY FOR DISSATISFACTION WITH THE
                SERVICES, MATERIALS, INCLUDING ANY PRODUCTS OR SERVICES AVAILABLE THROUGH
                ANY THIRD PARTY PLATFORM, SUBMISSIONS OR ANY LINKED WEBSITES, IS TO STOP
                USING THE SERVICES, CONTENT, MATERIALS, SUBMISSIONS, PRODUCTS, OR LINKED
                WEBSITES, AS APPLICABLE. THE SOLE AND EXCLUSIVE MAXIMUM LIABILITY TO THE
                FOUNDATION FOR ALL DAMAGES, LOSSES AND CAUSES OF ACTION, WHETHER IN
                CONTRACT, TORT (INCLUDING WITHOUT LIMITATION, NEGLIGENCE) OR OTHERWISE,
                SHALL BE THE TOTAL AMOUNT PAID BY YOU TO UA IN THE PRECEDING TWELVE (12)
                MONTHS, IF ANY, TO ACCESS OR USE THE SERVICES.
</p>
            <p>
                THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED OR
                LIMITED UNDER APPLICABLE LAW.
</p>
            <h3>
                <a name="_2wspnjwb9dk5"></a>
                <strong>Indemnification</strong>
            </h3>
            <p>
                You agree to defend, indemnify and hold harmless UA, its affiliates,
                licensors and service providers, and its and their respective officers,
                directors, employees, contractors, agents, licensors, suppliers, successors
                and assigns from and against any claims, liabilities, damages, judgments,
                awards, losses, costs, expenses or fees (including reasonable
                attorneys&#8217; fees) arising out of or relating to your violation of
                these Terms of Use or your use of the Services, including, but not limited
                to, your User Contributions, any use of the Content, services and products
                other than as expressly authorized in these Terms of Use or your use of any
                information obtained from the Services.
</p>
            <h3>
                <a name="_w86vxud7rtms"></a>
                <strong>Governing Law and Jurisdiction</strong>
            </h3>
            <p>
                All matters relating to the Services and these Terms of Use and any dispute
                or claim arising therefrom or related thereto (including non-contractual
                disputes or claims), shall be governed by and construed in accordance with
                the internal laws of the State of Alabama without giving effect to any
                choice or conflict of law provision or rule (whether of the State of
                Alabama or any other jurisdiction).
</p>
            <p>
                Any legal suit, action or proceeding arising out of, or related to, these
                Terms of Use or the Services shall be instituted exclusively in the
                appropriate court in the State of Alabama in each case located in the City
                of Fort Payne and County of Dekalb. You waive any and all objections to the
                exercise of jurisdiction over you by such courts and to venue in such
                courts.
</p>
            <h3>
                <a name="_uomamko94n8w"></a>
                <strong>Limitation on Time to File Claims</strong>
            </h3>
            <p>
                ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING TO
                THESE TERMS OF USE OR THE WEBSITE MUST BE COMMENCED WITHIN EIGHTEEN (18)
                MONTHS AFTER THE CAUSE OF ACTION ACCRUES, OTHERWISE, SUCH CAUSE OF ACTION
                OR CLAIM IS PERMANENTLY BARRED.
</p>
            <h3>
                <a name="_tbx2tiw97xfs"></a>
                <strong>Waiver and Severability</strong>
            </h3>
            <p>
                No waiver by UA of any term or condition set forth in these Terms of Use
                shall be deemed a further or continuing waiver of such term or condition or
                a waiver of any other term or condition, and any failure of UA to assert a
                right or provision under these Terms of Use shall not constitute a waiver
                of such right or provision.
</p>
            <p>
                If any provision of these Terms of Use is held by a court or other tribunal
                of competent jurisdiction to be invalid, illegal or unenforceable for any
                reason, such provision shall be eliminated or limited to the minimum extent
                such that the remaining provisions of the Terms of Use will continue in
                full force and effect.
</p>
            <h3>
                <a name="_180getwqbvkl"></a>
                <strong>Changes to the Terms of Use</strong>
            </h3>
            <p>
                We may revise and update these Terms of Use from time to time. We will
                notify you of such changes by posting the modified version on our Website
                and indicating the date it was last modified, and, if the changes are
                significant, we will provide a more prominent notice (including by email in
                certain instances). The date these Terms of Use were last modified is at
                the top of this page. We encourage you to visit our Website periodically to
                view the latest version of these Terms of Use. All changes are effective
                immediately when we post them, and apply to all access to and use of the
                Services thereafter. Your continued use of the Services following the
                posting of revised Terms of Use means that you accept and agree to the
                changes and updated Terms of Use.
</p>
            <h3>
                <a name="_ci8ivzvsxbli"></a>
                <strong>Entire Agreement</strong>
            </h3>
            <p>
                The Terms of Use, our Privacy Policy, and the Acceptable Use Policy
                constitute the sole and entire agreement between you and the Foundation
                with respect to the Services and supersede all prior and contemporaneous
                understandings, agreements, representations and warranties, both written
                and oral, with respect to the Services.
</p>
            <h3>
                <a name="_80dqjkebuxb3"></a>
                <strong>Contact Us</strong>
            </h3>
            <p>
                These Services and website are provided by Understanding Ag, LLC, 1908 Spring Drive NW
    <br />
    Fort Payne AL 35968
</p>
            <p>
                All other feedback, comments, requests for technical support and other
                communications relating to the Services should be directed to:
                support@regenagonline.com, mailed to the address above, Attention: Understanding Ag, LLC, or by phone at 256-996-3142.
</p>
        </div>
    );
};


export default TermsOfUse;